export enum ProvisionsUnit {
    UNIDAD = 'unidad',
    PAQUETE = 'paquete',
    BOLSA_BOLSON = 'bolsa/bolson',
    CAJA = 'caja',
}
